import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {setPageTitle} from "../../application.actions";
import * as actions from "./record.actions";
import * as applicationSelectors from "../../application.selectors";
import * as selectors from "./record.selectors";
import {Documentation, FormControls, RecordInfo, RecordUploadInfo} from "./components";
import * as recordStatus from './record.status';
import {WarningButton, DefaultButton, Modal} from "../../components";

class RecordUploadContainer extends React.Component {
  state = {showModal: false, file: {}};
  
  showModal = (recordId) => (file) => this.setState(({showModal: true, recordId, file}));
  hideModal = () => this.setState(({showModal: false}));
  
  componentWillMount() {
    const {actions: {setPageTitle}} = this.props;
    setPageTitle('PASRR Review > Record Upload');
  }

  uploadFile = (recordId) => file =>
    this.props.actions.uploadDocumentation(recordId, file);

  deleteFile = (recordId, file) => () => {
      this.props.actions.deleteDocumentation(recordId, file);
      this.hideModal();
  }
    
  downloadFile = (recordId) => async ({id}) => {
    const url = await this.props.actions.getDocumentationUrl(recordId, id);
    window.open(url, 'epasrr_documentation')
  };

  renderModal() {
    const {showModal, recordId, file} = this.state;
    return (
      <Modal
        show={showModal}
        title="Delete File"
        onClose={this.hideModal}
        body={<div>Are you sure you want to delete {file.fileName}?</div>}
        footer={
          <React.Fragment>
            <DefaultButton onClick={this.hideModal}>Cancel</DefaultButton>
            <WarningButton onClick={this.deleteFile(recordId, file)}>Yes</WarningButton>
          </React.Fragment>
        }
      />
    )
  }

  render() {
    const {period, record, documentation, roles, history, actions} = this.props;
    return (
      <div>
        <RecordInfo
          period={period}
          record={record}
          editable={roles.admin}
          onSave={actions.updateRecord}
        />
        <Documentation
          roles={roles}
          record={record}
          documentation={documentation}
          onUpload={this.uploadFile(record.id)}
          onDelete={this.showModal(record.id)}
          onFileClick={this.downloadFile(record.id)}
        />

        <RecordUploadInfo record={record}/>

        <hr/>

        <FormControls
          disabled={!roles.admin && record.recordStatusValue >= 3}
          completeText="Submit"
          onClose={() => history.goBack()}
          enableComplete={documentation.length > 0}
          showSave={false}
          showComplete={documentation.length > 0 && record.recordStatus === recordStatus.UploadInProgress}
          onSubmit={() => this.props.actions.submitRecord(true)}
          onSave={() => this.props.actions.submitRecord(false)}
        />
        {this.renderModal()}
      </div>
    );
  }
}

RecordUploadContainer.propTypes = {};


export default connect(
  (state) => ({
    record: selectors.record(state),
    period: selectors.period(state),
    documentation: selectors.documentation(state),
    roles: applicationSelectors.roles(state)
  }),
  dispatch => ({
    actions: bindActionCreators({...actions, setPageTitle}, dispatch)
  })
)(RecordUploadContainer);



// WEBPACK FOOTER //
// ./src/modules/record/RecordUploadContainer.js